import { KitcenSinkRowItemDataItem } from 'store-types';

export const SET_CURRENT_VIDEO = 'SET_CURRENT_VIDEO' as const;

export const setCurrentVideo = (
  video: KitcenSinkRowItemDataItem | null,
  videoId: string,
  rowId: string,
  isDiscoveryRowVideo: boolean,
) => ({
  type: SET_CURRENT_VIDEO,
  payload: { video, videoId, rowId, isDiscoveryRowVideo },
});
